<template>
  <div>
    <div class="page-breadcrumb">
      <div class="row">
        <div class="col-5 align-self-center">
          <h4 class="page-title">
            <i class="fas fa-user-circle" /> My Account
          </h4>
          <div class="d-flex align-items-center">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link :to="{name: 'dashboard'}">
                    Home
                  </router-link>
                </li>
                <li aria-current="page" class="breadcrumb-item active">
                  <strong>My Account</strong>
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div class="col-7 align-self-center">
          <div class="d-flex no-block justify-content-end align-items-center" />
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-3 col-xlg-3 col-md-5">
          <div class="card">
            <div class="card-body text-center">
              <div class="profile-pic m-b-20 m-t-20">
                <blockie :address="currentUser.email" class="blockie" />
                <h4 class="m-t-20 m-b-0">
                  {{ currentUser.first_name }}&nbsp;{{ currentUser.last_name }}
                </h4>
                <a>{{ currentUser.email }}</a>
              </div>
            </div>
            <!--                        <div class="p-25 border-top m-t-15">-->
            <!--                            <div class="row text-center">-->
            <!--                                <div class="col-6 border-right">-->
            <!--                                    <router-link :to="{ name: 'viewprofile'}" class="link d-flex align-items-center justify-content-center font-medium">-->
            <!--                                        <i class="mdi mdi-account font-20 m-r-5"></i>&nbsp; Account Info-->
            <!--                                    </router-link>-->
            <!--                                </div>-->
            <!--                                <div class="col-6">-->
            <!--                                    <router-link :to="{name: 'mywallet'}" class="link d-flex align-items-center justify-content-center font-medium">-->
            <!--                                        <i class="mdi mdi-wallet font-20 m-r-5"></i>&nbsp;My Wallet-->
            <!--                                    </router-link>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
          </div>
        </div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Blockie from '../common/Blockie'

export default {
  name: 'MyAccountLayout',
  components: { Blockie },
  data () {
    return {
      org: {}
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  }
}
</script>

<style scoped>
.blockie {
  width: 120px;
}
</style>
